import {AxiosProcessor} from "../../shared/axios/AxiosProcessor";
const urlAuthorizationRule = '/authorizationRule';

const state = {
    authorizationRule: {},
    authorizationRules: []
};

const getters = {
    getAuthorizationRule: state => {
        return state.authorizationRule;
    },
    getAuthorizationRules: state => {
        return state.authorizationRules;
    }
};

const mutations = {
    setAuthorizationRule: (state, data) => {
        state.authorizationRule = data;
    },
    setAuthorizationRules: (state, data) => {
        state.authorizationRules = data;
    }
};

const actions = {
     setAuthorizationRule: async ({commit}, data) => {
        //going backend
        let value = {};

        if(!!!data.id) {
            value  = await AxiosProcessor.post(urlAuthorizationRule, data);
        }
        else {
            value = await AxiosProcessor.put(urlAuthorizationRule+'/'+ data.id, data);
        }

        commit('setAuthorizationRule', value);
    },
    async getAuthorizationRule ({commit}, data){
        let id = data.id;

        if (!id)
            throw {message: 'empty id. Please provide a valid id value'};

        let authorizationRule;
        let value = {};

        if (state.authorizationRules.length > 0) {
            authorizationRule  = state.authorizationRules.find(doc => doc.id === id);
        }

        if(authorizationRule) {
            value = authorizationRule;
        }
        else {
            let response = await AxiosProcessor.get(urlAuthorizationRule +'/'+id);

            if(response.Item)
                value = response.Item;
        }

        commit('setAuthorizationRule', value);
    },
    async getAuthorizationRules ({commit}, data){
        //going backend,
        let value = [];
        let response = await AxiosProcessor.list(urlAuthorizationRule, data);

        if(!!!!response && response.Items)
            value = response.Items;

        commit('setAuthorizationRules', value);
    },
    async deleteAuthorizationRule ({commit}, data){
        //going backend,
        let value = {};
        value = await AxiosProcessor.delete(urlAuthorizationRule+'/'+data.id);

        commit('setAuthorizationRule', value);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}